// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__5dHBW","tab":"ProcedureTabs_tab__1sEn3"};